import { memo } from 'react';

import { usePageEvent } from '@bonnet/next/use-page-event';

import { sendPage } from 'reaxl-analytics';

const BapPageEventsContainer = memo(() => {
    const { onPageEnter } = usePageEvent('bapPage', { priority: 1 });

    onPageEnter(async () => {
        sendPage({
            isInitialLoad: true,
        });
    });

    return null;
});

export default BapPageEventsContainer;
